var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 1.804 13.696.5 7.5 6.696 1.304.5 0 1.804 6.196 8 0 14.196 1.304 15.5 7.5 9.304l6.196 6.196L15 14.196 8.804 8 15 1.804Z"
})));
export default SvgClose;